import { formatDollar, numericAddCommas } from "@modernary/mui/utils/filters";

export const STARTING_REPORT_YEAR = 2000;

export const calculateContainerFee = (containerCount: number | undefined) => {
  const value = Number(containerCount);
  if (isNaN(value)) return undefined;
  return value * 0.01;
};

export const calculateDepositAmount = (containerCount: number | undefined) => {
  const value = Number(containerCount);
  if (isNaN(value)) return undefined;
  return value * 0.05;
};

export const calculateTotalDue = (containerCount: number | undefined) => {
  const value = Number(containerCount);
  if (isNaN(value)) return undefined;
  const containerFee = calculateContainerFee(containerCount) ?? 0;
  const depositAmount = calculateDepositAmount(containerCount) ?? 0;
  return containerFee + depositAmount;
};

export const calculateTotals = (allContainerCounts: number, baselineContainerCounts: number) => {
  return {
    containerCount: allContainerCounts,
    baselineContainerCount: baselineContainerCounts,
    containerFeeAmount: calculateContainerFee(allContainerCounts),
    depositAmount: calculateDepositAmount(allContainerCounts),
    totalDue: calculateTotalDue(allContainerCounts),

    varianceContainerCount: allContainerCounts - baselineContainerCounts,
    varianceContainerFeeAmount: calculateContainerFee(allContainerCounts - baselineContainerCounts),
    varianceDepositAmount: calculateDepositAmount(allContainerCounts - baselineContainerCounts),
    varianceTotalDue: calculateTotalDue(allContainerCounts - baselineContainerCounts),
  };
};

export const formatContainerDollarValue = (val: string | number | null | undefined) => {
  const value = Number(val);
  if (isNaN(value)) return undefined;
  return formatDollar(value) as string;
};

export const formatContainerValue = (val: string | number | null | undefined) => {
  const value = Number(val);
  if (isNaN(value)) return undefined;
  return numericAddCommas(value) as string;
};
